module.exports = __webpack_public_path__ + "static/media/Artboard7.0a971892.png";